// src/context/MenuContext.tsx
import React, { createContext, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuItem } from "primereact/menuitem";

interface MenuContextValue {
    items: MenuItem[];
}

const MenuContext = createContext<MenuContextValue>({ items: [] });

export const MenuProvider = ({ children }: { children: React.ReactNode }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const isCompanyActive = pathname.startsWith("/about-us") || pathname.startsWith("/faq") || pathname.startsWith("/terms-of-use") || pathname.startsWith("/contact-us");

    const items = useMemo(() => [
        {
            label: "Individuals",
            command: () => navigate("/individuals"),
            style: { fontSize: "1.25rem", fontWeight: 600 },
            className: pathname === "/individuals" ? "p-focus" : pathname === "/preview" ? "text-white" : "",
        },
        {
            label: "Health Providers",
            command: () => navigate("/healthcare-providers"),
            style: { fontSize: "1.25rem", fontWeight: 600 },
            className: pathname === "/healthcare-providers" ? "p-focus" : pathname === "/preview" ? "text-white" : "",
        },
        {
            label: "Company",
            style: { fontSize: "1.25rem", fontWeight: 600 },
            className: pathname === "/preview" ? "text-white white-icon" : isCompanyActive ? "p-focus" : "",
            items: [
                {
                    label: "About Us",
                    command: () => navigate("/about-us"),
                    style: { fontSize: "1.25rem", fontWeight: 600 },
                    className: pathname === "/about-us" ? "p-focus" : "",
                },
                {
                    label: "FAQs",
                    command: () => navigate("/faq"),
                    style: { fontSize: "1.25rem", fontWeight: 600 },
                    className: pathname === "/faq" ? "p-focus" : "",
                },
                {
                    label: "Terms of Use",
                    command: () => navigate("/terms-of-use"),
                    style: { fontSize: "1.25rem", fontWeight: 600 },
                    className: pathname === "/terms-of-use" ? "p-focus" : "",
                },
                {
                    label: "Contact Us",
                    command: () => navigate("/contact-us"),
                    style: { fontSize: "1.25rem", fontWeight: 600 },
                    className: pathname === "/contact-us" ? "p-focus" : "",
                }
            ]
        }
    ], [pathname, navigate]);

    return (
        <MenuContext.Provider value={{ items }}>
            {children}
        </MenuContext.Provider>
    );
};

export const useMenu = () => useContext(MenuContext);
